import React, { ReactNode } from "react";
import LightGallery from "lightgallery/react";
// import styles
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";
import "lightgallery/css/lg-rotate.css";

// import plugins if you need
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import lgRotate from "lightgallery/plugins/rotate";

type Props = {
  children: ReactNode;
  /**
   * CSS selector for the gallery items, when the thing that should open the
   * viewer is NOT the direct child of the gallery.
   *
   * lightGallery's default is "every direct child", which is right where a card
   * IS the image (DocumentCard). It is wrong where the card also carries
   * controls — a delete button inside a direct child would open the viewer as
   * well as delete. Pointing at an inner element instead keeps the trigger on
   * the image and leaves the controls alone; elements that do not match (a PDF
   * tile, say) simply stay out of the gallery.
   *
   * Left undefined, the component behaves exactly as it always has.
   */
  selector?: string;
};

const ATMImageZoomer = ({ children, selector }: Props) => {
  return (
    <div className="gallery">
      <LightGallery
        speed={500}
        plugins={[lgThumbnail, lgZoom, lgRotate]}
        actualSize
        {...(selector ? { selector } : {})}
      >
        {children}
      </LightGallery>
    </div>
  );
};

export default ATMImageZoomer;
